import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const WebinarsSection = () => {
  const webinars = [
    {
      id: 'search',
      title: 'Вебинар: Поиск отношений',
      description: 'Современные методы поиска партнёра, их эффективность и стоимость. Психологи и социологи помогут разобраться в личных вопросах.',
      icon: 'Search',
      color: 'blue',
      link: '/relationship-search-webinar-page',
      features: [
        'Обзор современных методов знакомств',
        'Сравнение эффективности и стоимости',
        'Ответы на личные вопросы',
        'Помощь специалистов по психологии'
      ]
    },
    {
      id: 'improvement',
      title: 'Вебинар: Улучшение отношений',
      description: 'Для тех, кто в отношениях. Семейные психологи расскажут о методах снижения конфликтов и улучшения взаимопонимания.',
      icon: 'Heart',
      color: 'pink',
      link: '/relationship-improvement-webinar-page',
      features: [
        'Методы снижения конфликтов',
        'Улучшение коммуникации в паре',
        'Работа с семейными психологами',
        'Практические инструменты для пар'
      ]
    }
  ];

  return (
    <section id="webinars" className="py-20 bg-gradient-to-b from-background to-background-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
            Бесплатные вебинары
          </h2>
          <p className="text-xl text-foreground/70 max-w-3xl mx-auto">
            Присоединяйтесь к нашим образовательным вебинарам с ведущими психологами и социологами
          </p>
        </div>

        {/* Webinar Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {webinars.map((webinar) => (
            <div
              key={webinar.id}
              className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              {/* Card Header */}
              <div className={`p-8 ${
                webinar.color === 'blue' ?'bg-gradient-to-br from-blue-50 to-blue-100' :'bg-gradient-to-br from-pink-50 to-pink-100'
              }`}>
                <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-4 ${
                  webinar.color === 'blue' ? 'bg-blue-500' : 'bg-pink-500'
                }`}>
                  <Icon name={webinar.icon as any} size={32} color="white" />
                </div>
                <h3 className="text-2xl font-bold text-foreground mb-3">
                  {webinar.title}
                </h3>
                <p className="text-foreground/70">
                  {webinar.description}
                </p>
              </div>

              {/* Card Body */}
              <div className="p-8">
                <ul className="space-y-3 mb-8">
                  {webinar.features.map((feature, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <Icon 
                        name="Check" 
                        size={20} 
                        className={webinar.color === 'blue' ? 'text-blue-500 mt-0.5' : 'text-pink-500 mt-0.5'} 
                      />
                      <span className="text-foreground/80">{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Button */}
                <Link
                  to={webinar.link}
                  className={`block w-full text-center py-4 px-6 rounded-xl font-semibold transition-all duration-300 ${
                    webinar.color === 'blue' ?'bg-blue-500 hover:bg-blue-600 text-white' :'bg-pink-500 hover:bg-pink-600 text-white'
                  }`}
                >
                  Узнать подробнее
                  <Icon name="ArrowRight" size={20} className="inline-block ml-2" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="text-center mt-12">
          <p className="text-foreground/60 text-sm">
            Вебинары проводятся опытными специалистами с многолетним стажем
          </p>
        </div>
      </div>
    </section>
  );
};

export default WebinarsSection;